export class MovimientoCreateDto {
    constructor() {
        this.idPaciente = null;
        this.idAreaSolicitud = null;
        this.idClinica = null;
        this.idEmpleadoSolicito = null;
        this.idTipoMovimiento = null;
        this.monto = null;
        this.folioPolizaContableErp = null;
        this.archivos = [];
    }
}